import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "../../Components/Common/Header";
import { colors } from "../../theme/theme";
import SearchBar from "../../Components/Common/SearchBar";
import Tags from "../../Components/Home/Tags";
import ProductCards from "../../Components/Home/ProductCards";
import axios from "axios";
import { tags } from "../../assets/dummyData";
import Footer from "../../Components/Common/Footer";
import config from "../../config/config";
import BrandLogoSlider from "../../Components/Home/BrandLogoSlider";
import { useDispatch, useSelector } from "react-redux";
import { fetchCollections } from "../../redux/slices/collectionsSlice";

const HomePage = () => {
  const dispatch = useDispatch();

  const { collections } = useSelector((state) => state.collections);

  const [search, setSearch] = useState("");
  const [location, setLocation] = useState({ lat: null, lng: null });
  const [nearestMall, setNearestMall] = useState({ name: "" });
  const [allMall, setAllMall] = useState([]);
  const [error, setError] = useState(null);
  const [allCollections, setAllCollections] = useState([]);
  const [showDropDown, setShowDropDown] = useState(false);
  const [ipInfo, setIpInfo] = useState({ latitude: null, longitude: null });

  const fetchLocation = async (lat, lng) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          const nearestMallResponse = await axios.get(
            `${config.backendUrl}/location/get_nearest_mall?lat=${latitude}&lng=${longitude}`
          );

          // console.log("response", nearestMallResponse)
          setNearestMall({ name: nearestMallResponse.data?.mall?.name });
          setAllMall(nearestMallResponse.data?.allMalls);
        },
        async (err) => {
          setError(
            "Unable to fetch location. Please enable location services."
          );
          fetchLocationViaIp(lat, lng);
        }
      );
    } else {
      fetchLocationViaIp(lat, lng);
    }
  };

  const fetchLocationViaIp = async (lat, lng) => {
    axios
      .get(
        `${config.backendUrl}/location/get_nearest_mall?lat=${lat}&lng=${lng}`
      )
      .then((response) => {
        setNearestMall({ name: response.data?.mall?.name });
        setAllMall(response.data?.allMalls);
        // setError("Geolocation is not supported by your browser.");
      });
  };

  const getAllCollections = async () => {
    let search = [];
    search.push("best women dress");
    search.push("Shirts");
    search.push("winter jackets & hoodies");
    search.push("Shoes Slide");
    //search.push("best men dress");
    search.push("Perfumes");
    search.push("Watches");

    axios
      .get(`${config.backendUrl}/inventory/batch_search`, {
        params: { q: search },
      })
      .then((response) => {
        console.log(response.data?.results?.responses);
        setAllCollections(response.data?.results?.responses);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  useEffect(() => {
    dispatch(fetchCollections());
  }, []);

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box sx={{ backgroundColor: "#FEFEFE" }}>
      <Header />
      {/* <Box sx={{ mt: 3, mx: 3 }}>
        {showDropDown === false ? (
          <Typography
            sx={{
              fontFamily: "Poppins-ExtraLight",
              fontSize: "12px",
              color: colors.textColor,
            }}
          >
            Location
          </Typography>
        ) : (
          ""
        )}

        <Stack direction="row" alignItems="center">
          {showDropDown === false ? (
            <>
              <MyLocationSharp
                sx={{ color: "#4FCE00", height: "12px", width: "12px" }}
              />
            </>
          ) : (
            <>
              <CloseOutlinedIcon
                onClick={() => {
                  setShowDropDown(false);
                }}
                sx={{ color: "#4FCE00", height: "12px", width: "12px" }}
              />
            </>
          )}
          {showDropDown === false ? (
            <>
              <Typography
                sx={{
                  fontFamily: "Poppins-Medium",
                  fontSize: "14px",
                  color: colors.textColor,
                  ml: 1,
                }}
              >
                {nearestMall?.name}&nbsp;&nbsp;
                <Typography
                  component={"span"}
                  sx={{
                    color: "#82b1ff",
                    textDecoration: "underline",
                    BorderBottom: "1px solid #82b1ff",
                    fontSize: "12px",
                  }}
                  onClick={() => {
                    setShowDropDown(true);
                  }}
                >
                  Update location?
                </Typography>
              </Typography>
            </>
          ) : (
            <>
              <CreateDropDown
                value={nearestMall?.name}
                setValue={(value) => {
                  setNearestMall({ name: value });
                  setShowDropDown(false);
                }}
                title="Location"
                data={allMall}
                noIcon
              />
            </>
          )}
        </Stack>
      </Box> */}

      {/* Search Box */}
      <Box
        sx={{
          mx: 2,
          mb: 2,
          borderTopLeftRadius: "28px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "28px",
          borderBottomRightRadius: "28px",
          py: 1,
          px: 2,
          backgroundColor: colors.pinkColor,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-SemiBold",
            fontSize: "32px",
            color: colors.textColor,
            maxWidth: "80%",
            lineHeight: "34px",
            mb: 2,
            mt: 1,
          }}
        >
          What Are You shopping for?
        </Typography>
        <SearchBar search={search} setSearch={setSearch} />
      </Box>

      <Box
        sx={{
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          mx: 2,
          mb: 2,
        }}
      >
        <BrandLogoSlider />
      </Box>

      {collections &&
        collections?.map((collection) => {
          return (
            <Box
              sx={{
                borderRadius: "20px",
                backgroundColor: "#fff",
                boxShadow: "-1px -2px 15px 0px #00000012",
                ml: 2,
                mr: smallScreen ? 0 : 2,
                mb: 2,
                overflowX: "hidden",
                position: "relative",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins-Bold",
                  fontSize: "20px",
                  color: colors.textColor,
                  mx: 2,
                  py: 2,
                  textTransform: "capitalize",
                }}
              >
                {collection.query}
              </Typography>

              <ProductCards productData={collection.products || []} />
            </Box>
          );
        })}
      {/* <Box
        sx={{
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          ml: 2,
          mb: 2,
          overflowX: "visible",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-Bold",
            fontSize: "20px",
            color: colors.textColor,
            mx: 2,
            py: 2,
          }}
        >
          Clothing Collection
        </Typography>

        <ProductCards productData={allCollections?.menProducts || []} />
      </Box> */}
      {/* Watch Collection Card */}
      {/* <Box
        sx={{
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          ml: 2,
          mb: 2,
          overflowX: "visible",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-Bold",
            fontSize: "20px",
            color: colors.textColor,
            mx: 2,
            py: 2,
          }}
        >
          Watch Collection
        </Typography>

        <ProductCards productData={allCollections?.watchProducts || []} />
      </Box> */}
      {/* Perfume Collection Card */}
      {/* <Box
        sx={{
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          mx: 2,
          mb: 2,
          overflowX: "visible",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-Bold",
            fontSize: "20px",
            color: colors.textColor,
            mx: 2,
            py: 2,
          }}
        >
          Perfume Collection
        </Typography>

        <ProductCards productData={allCollections?.perfumeProducts || []} />
      </Box> */}
      {/* Perfume Collection Card */}
      {/* <Box
        sx={{
          borderRadius: "20px",
          backgroundColor: "#fff",
          boxShadow: "-1px -2px 15px 0px #00000012",
          mx: 2,
          mb: 2,
          overflowX: "visible",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins-Bold",
            fontSize: "20px",
            color: colors.textColor,
            mx: 2,
            py: 2,
          }}
        >
          Women Collection
        </Typography>

        <ProductCards productData={allCollections?.womenProducts || []} />
      </Box> */}
      {/* Banner */}
      {/* <img
        src={require("../../assets/images/banner1.png")}
        alt="banner"
        style={{
          width: "100%",
          height: "10%",
          my: 2,
        }}
      /> */}
      <Footer />
    </Box>
  );
};

export default HomePage;
